import { Box, Button, Icon } from '@palmetto/palmetto-components';
import { useNavigate } from 'react-router-dom';

interface PtoRejectionBannerProps {
  accountId: string;
}

const PtoRejectionBanner = ({ accountId }: PtoRejectionBannerProps) => {
  const navigate = useNavigate();

  const handleReviewPto = () => {
    navigate(`/accounts/${accountId}/proof-of-pto/edit`);
  };

  return (
    <Box
      borderWidth="xxs"
      borderColor="danger"
      radius="md"
      direction={{ base: 'column', tablet: 'row' }}
      alignItems="stretch"
      fontSize="sm"
      overflow="hidden"
      background="badge-danger"
      shadow="xs"
      height="auto"
    >
      <Box padding="lg" direction="row">
        <Icon name="remove" size="2xl" color="danger" />
      </Box>
      <Box flex="auto" childGap="2xs" padding="lg" fontSize="md" color="danger">
        <Box fontWeight="bold">Proof of PTO Rejected</Box>
        <Box fontWeight="medium">
          Please review rejection reasons and provide new documents to complete the PTO requirement.
        </Box>
      </Box>
      <Box padding={{ base: '0 lg lg lg', tablet: 'lg' }} justifyContent="center">
        <Button
          as="a"
          variant="primary"
          tone="danger"
          size={{ base: 'sm', desktop: 'md' }}
          aria-label="review rejected PTO"
          navigate={handleReviewPto}
        >
          Review PTO
        </Button>
      </Box>
    </Box>
  );
};

export default PtoRejectionBanner;
